import "../styles/demand.css";
import genAiTrendImg from "../assets/Gen_AI_Future_trend.png";
import demandChartImg from "../assets/demand-chart.png";
import dataAnalyticsTrendImg from "../assets/data-analytics-demand-chart.png"; // 👈 add your image

export default function Demand({ type = "genai" }) {
  const content = {
    genai: {
      title: "Industry Demand",
      span: "2025 – 2026",
      description:
        "Rapidly increasing demand for Generative AI professionals across startups, enterprises, and global technology companies.",
      image: genAiTrendImg,
      alt: "Generative AI Future Trends",
    },

    dataAnalytics: {
      title: "Data Analytics Demand",
      span: "2025 – 2026",
      description:
        "Strong global demand for Data Analysts driven by data-driven decision making, business intelligence, and AI-powered analytics across industries.",
      image: dataAnalyticsTrendImg,
      alt: "Data Analytics Industry Demand",
    },
  };

  const current = content[type];

  return (
    <section className="demand-section">
      {/* HEADER */}
      <div className="demand-header">
        <h2>
          {current.title} <span>{current.span}</span>
        </h2>

        <p>{current.description}</p>
      </div>

      {/* IMAGE */}
      <div className="demand-image-wrapper">
        <img src={current.image} alt={current.alt} />
      </div>
    </section>
  );
}
